/**
 * Rotas do portal do paciente (docs/areas/portal-do-paciente.md), em um só lugar. Links e "Voltar"
 * usam estas funções — nunca strings soltas. Em inglês, como as do sistema (T21); o endereço
 * público é paciente.westhetics.io (P-POR-06).
 */
export const routes = {
  /** Entrar com o código por e-mail (RN-POR-02). `?reason=expired` quando a sessão terminou. */
  signIn: '/sign-in',
  signInExpired: '/sign-in?reason=expired',
  /** Cadastro pelo link da clínica (RN-POR-18): público, com o token em `?t=`. */
  register: '/register',
  /** A paciente lê e assina pelo link (RN-ASS-15 a 23, T38): público, com o token em `?t=`. */
  sign: '/sign',
  /** O início: a linha do tempo de atendimentos, fichas de saúde e planos (RN-POR-04, RN-POR-23). */
  home: '/',
  appointment: (id: string) => `/appointments/${id}`,
  document: (id: string) => `/documents/${id}`,
  anamnesis: (id: string) => `/anamneses/${id}`,
  treatmentPlan: (id: string) => `/treatment-plans/${id}`,
} as const
